import React from "react";
import {useTranslation} from "react-i18next";
import clock from "../../img/big/clock.webp";
import compass from "../../img/big/localisation.webp";

export default function HomeInformationsComponent(props) {
    const {t} = useTranslation();

    return (
        <div
            className={`flex ${props.isMobile ? 'flex-col items-center' : 'items-center justify-center'} gap-6 p-h-20 p-w-10 ${props.width ?? ''} ${props.color ?? ''}`}
        >
            <div className="w-full flex flex-col items-center gap-6">
                <h2 className={`w-fit ${props.border ?? ""}`}>{t("HOME.OPENING")}</h2>

                <div className="flex item-center justify-center gap-6">
                    <img src={clock} alt="clock" className="picto"/>

                    <div className="text-center">
                        <p className="f-s-20">{t("HOME.OPENING_DAYS_1")}</p>
                        <p className="f-s-20 m-t-10">{t("HOME.OPENING_HOURS_1")}</p>
                        <p className="f-s-20 m-t-10">{t("HOME.OPENING_HOURS_2")}</p>
                        <p className="f-s-20 m-t-10">{t("HOME.OPENING_DAYS_2")}</p>
                        <p className="f-s-20 m-t-10">{t("HOME.OPENING_HOURS_3")}</p></div>
                </div>
            </div>

            <div className="w-full flex flex-col items-center gap-6">
                <h2 className={`w-fit ${props.border ?? ""}`}>{t("HOME.ADDRESS")}</h2>

                <div
                    className={`flex ${props.isMobile ? 'flex-row' : 'flex-row-reverse'} item-center justify-center gap-6`}>
                    <div className="text-center">
                        <p className="f-s-20">134 boulevard Henri Sellier</p>
                        <p className="f-s-20 m-t-10">92150 Suresnes</p>
                    </div>

                    <img src={compass} alt="compass" className="picto"/>
                </div>
            </div>
        </div>
    );
}
